import React from 'react';
import { motion } from 'framer-motion';
import { Building2, TrendingUp, Award } from 'lucide-react';
const highlights = [{
  icon: Building2,
  title: '$8B+ Design-Build Construction Programs',
  description: 'Directed the development of baseline frameworks and led comprehensive CPM scheduling for large-scale design-build construction programs valued at $8B+, ensuring precise planning, execution efficiency, and on-time delivery across complex, multi-stakeholder environments.'
}, {
  icon: Award,
  title: 'AdvantaClean Corporate Account Expansion',
  description: 'Spearheaded AdvantaClean corporate account expansion, securing and managing national partnerships with Home Depot, Fidelity, and Santander Bank, while independently handling 300+ insurance claims and delivering major remediation and rehabilitation projects for institutions including Hartford Public Library, New Britain Public Schools, U.S. Coast Guard Academy, U.S. Naval Base, UMASS, healthcare facilities, and other commercial clients—driving $5M+ in revenue.'
}, {
  icon: TrendingUp,
  title: 'Molly Maid Operational Excellence',
  description: 'Achieved strong operational and revenue performance at Molly Maid, generating $1.8M in sales over 3.5 years through consistent client growth, service excellence, and effective business development strategies.'
}];
export function CareerHighlights() {
  return <section className="py-20 bg-corporate-gray" data-id="element-31">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-33">
          <h2 className="text-2xl md:text-3xl font-bold text-corporate-blue mb-4" data-id="element-34">
            Career Highlights
          </h2>
          <div className="w-20 h-1 bg-corporate-teal rounded-full" data-id="element-35"></div>
        </motion.div>

        <div className="grid grid-cols-1 gap-8" data-id="element-36">
          {highlights.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#FDFBF7] p-6 rounded-lg shadow-sm border-l-4 border-corporate-blue hover:shadow-md transition-shadow" data-id="element-37">
              <div className="flex items-start gap-4 mb-3" data-id="element-38">
                <div className="w-11 h-11 bg-corporate-teal/10 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-39">
                  <item.icon className="text-corporate-teal" size={22} data-id="element-40" />
                </div>
                <h3 className="text-lg font-bold text-corporate-blue pt-2" data-id="element-41">
                  {item.title}
                </h3>
              </div>

              <p className="text-[#6B6356] text-sm leading-relaxed" data-id="element-42">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}